import api from '../utils/api';
export const inboxSync = () => {
    return api({
        url: '/api/messagelog/getInboxSync',
        method: 'GET'
    })
}
export const getEMRSync = () => {
    return api({
        url: '/api/messagelog/getEMRSync',
        method: 'GET'
    })
}

